var _style, _defs, _defs2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 706 754",
    style: {
      enableBackground: "new 0 0 706 754"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000044885244054373618320000004502104719018327691_);}\n\t.st1{clip-path:url(#SVGID_00000114776420411684144330000001237709746163257769_);}\n\t.st2{fill:#3294D1;}\n\t.st3{fill:#7BA7B8;}\n\t.st4{fill:#F08434;}\n\t.st5{fill:#6F7FA7;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -277,
    y: -122,
    width: 1258.9,
    height: 996.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151530721696463442970000005406073512393717150_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000151530721696463442970000005406073512393717150_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000133528539370226904510000006021151079554376597_",
    x: -277,
    y: -122,
    width: 1258.9,
    height: 996.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183233503326667460550000008713626425555152292_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133528539370226904510000006021151079554376597_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183233503326667460550000008713626425555152292_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M405.4,198.6c0-108.2-87.7-195.9-195.9-195.9S13.6,90.5,13.6,198.6s87.7,195.9,195.9,195.9 S405.4,306.8,405.4,198.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M384.2,649.4c0-55.6-45.1-100.7-100.6-100.7s-100.7,45.1-100.7,100.6S228,750,283.6,750c0,0,0,0,0,0 C339.2,750,384.2,705,384.2,649.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.3,523.1c0-51.9-42.1-94-94-94s-94,42.1-94,94s42.1,94,94,94S189.3,575,189.3,523.1L189.3,523.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M703.6,444.5c0-92.3-74.8-167.1-167.1-167.1s-167.1,74.8-167.1,167.1c0,92.3,74.8,167.1,167.1,167.1 C628.8,611.6,703.6,536.8,703.6,444.5C703.6,444.5,703.6,444.5,703.6,444.5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.d0b9c4283216c879ab8bd4b213d79060.svg";
export { ForwardRef as ReactComponent };